import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import Datatable from "components/Core/DataTable";
import CardType from "lib/Core/Backend/Controllers/CardType";
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import {
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup, Form, CustomInput,Input
} from "reactstrap";
import {MotionButton, MotionCard} from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import Notify from "lib/Utils/Alert";
import Papa from 'papaparse';
import html2pdf from "html2pdf.js";
import useBrands from "hooks/useBrands";
import Inventory from "lib/Core/Backend/Controllers/Inventory";
import HistoricalDataSkuModal from '../components/InventoryView/Modal/HistoricalDataSkuModal/HistoricalDataSkuModal'
import { useHistory } from "react-router";
import Select from "react-select";
import Spinner from 'react-bootstrap/Spinner';
import { FiEdit2 } from "react-icons/fi";

const dollar = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});

function InventoryView(props) {
	const { token,accessRoles} = props;
	const history = useHistory();
	const brands = useBrands();



	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const inventoryCtl = useMemo(() => new Inventory(token), [token]);
	const fileCtl = useMemo(() => new FileUpload(token), [token]);
	const [modal, setModal] = useState(false);
	const [downloadBrandsModal, setDownloadBrandsModal] = useState(false);
	const [data,setData] = useState([])
	const toggle = () => setModal(!modal);
	const toggleDownloadBrandsModal = () => setDownloadBrandsModal(!downloadBrandsModal);
	const [isModalHistoryOpen, setIsModalHistoryOpen] = useState(false);
	const [isThresholdModal,setIsThresholdModal] = useState(false);
	const toggleModalHistory = () => setIsModalHistoryOpen(!isModalHistoryOpen);
	const [warningModal,setWarningModal] = useState(false);
	const toggleWarning = () => setWarningModal(!warningModal);
    const toggleThreshold = () => setIsThresholdModal(!isThresholdModal)
	const [isEmpty, setIsEmpty] = useState(true);
	const [thresholdValue,setThresholdValue] = useState()
    const [currency, setCurrency] = useState('');
	const [currencyId,setCurrencyId] = useState();
	const [brandId,setBrandId] = useState()
	const [cardsLoading, setCardsLoading] = useState(true);
	const [cardTypes, setCardTypes] = useState([]);
	const [brandOption,setBrandOption] = useState([])
	const [cardTypeId,setCardTypeId] = useState()
	const [showDownload,setShowDownload] = useState(false)
	const [loader,setLoader] = useState(true)
	const [giftcardEditModal,setGiftcardEditModal] = useState(false)
	const [supplierEditModal,setSupplierEditModal] = useState(false);
	const [rowData,setRowData] = useState(null);
	const [stock,setStock] = useState()
	const [newCardType,setNewCardType] = useState(null)
	const [newCardTypeId,setNewCardTypeId] = useState()
	const [oldCardId,setOldCardId] = useState(null)
	const [brand,setBrand] = useState([])
	const [detailsData,setDetailsData] =useState([])
	const [supplierGiftCard,setSupplierGiftCard] = useState()
	const [supplierStock,setSupplierStock] = useState(null)
	const [supplierOption,setSupplierOption] = useState([])
	const [currentSuppplierId,setCurrentSupplierId] = useState()
	const [referenceId,setReferenceId] = useState()
	const [selectedChangeSupplier,setSelectedChangeSupplier] = useState([])
	const [newSupplierId,setNewSupplierId] = useState()
    const [ApiCallAgain,setApiCallAgain] = useState(1)
	const [giftCardLoader,setGiftcardLoader] = useState(false);
	const [supplierEditLoader,setSupplierEditLoader] = useState(false)
	
	const [singleEditModal,setSingleEditModal] = useState(false);
	const toggleGiftcard = () =>setGiftcardEditModal(!giftcardEditModal)
	const toggleSupplier = () => setSupplierEditModal(!supplierEditModal);
	const toggleSingleEdit = () =>setSingleEditModal(!singleEditModal);
	const form = useRef();
	const table = useRef();
	const alert = useRef();
    const brandSelect = useRef();
	const cardTypeSelect = useRef();


	const header = [		
		{title: 'SKU', data: 'sku', sortable: true, searchable: true},
		{title: 'Card Type', data: 'cardTypeName', sortable: true, searchable: true},
		{title: 'Brand', data: 'brand', sortable: true, searchable: true},
		{title: 'Value', data: 'faceValue', sortable: true, searchable: true, render: data => `${dollar.format(data)}`},
		{title: 'currency', data: 'currency', sortable: true, searchable: true, width: "10%"},
		{title: 'Stock', data: 'stock', sortable: true, searchable: true, render: data => `${data}`},
		{
			  title: 'Action',
			  data: 'status',
			  sortable:false,
			  render: (data, _, rowData) => {
				const dropdownOptions = generateDropdownOptions(data);
		
				// Render the dropdown
				return `
				<div class="d-flex justify-content-center w-100">
				<div class="main_class">
				<p><span></span><span></span><span></span></p>
				
				<select onchange="{() => handleMainDropdownChange}" class="dropdown_value" style="width:20px;cursor:pointer">
				 ${dropdownOptions.map((option) => (
		
				  `<option value="${option.value}" data-action="${option.action ? option.action.name : ''}">
						  ${option.label}
						</option>`
				)).join('')}
					</select></div>
			  </div>
					  
					
					  `;
			  },
			},
	];

	const validateFile = (e) => {
		e.preventDefault();
		Papa.parse(e.target.files[0], {
			download: true,
			header: true,
			complete: (result) => {
				if(result.data.length){
					setIsEmpty(false);
				} else {
					setIsEmpty(true);
				}
			}
		})
	}

	const uploadFile = () => {
		if(isEmpty){
			Notify(alert, 'danger', 'File is Empty')
			return
		} else {
			let file = document.getElementById('fileInput').files[0];
			fileCtl.add(file, data => {
				if(data.error || data.errorMessage){
					Notify(alert, 'danger', data.errorMessage ?? data.error)
				} else {
					Notify(alert, 'success', 'File succesfully uploaded')
					toggle();
				}
			})
		}
	}

	function generateDropdownOptions(data) {
		const options = [];
		options.push({
		  label: 'Select an action',
		  value: 'select_action',
		  action: null
		});
	
		options.push({
		  label: 'Edit GiftCard',
		  value: 'gittcard_edit',
	
		});
		options.push({
		  label: "Edit Supplier ",
		  value: "supplier_edit"
		})
		
	
		return options;
	  };

	const createTable = useCallback((data) =>
	{
		let tbl = document.createElement("table");
		let tblHead = document.createElement('thead');
		let tblBody = document.createElement("tbody");

		tbl.setAttribute('id', 'available-brands');

		tbl.classList.add('table', 'table-striped');
		tblHead.classList.add('thead-dark');

		let headers = document.createElement('tr');
		let headersArr = ['SKU', 'Card Type', 'Brand', 'Value', 'Currency', 'Stock'];
		headersArr.forEach(header =>
		{
			let cell = document.createElement('th');
			cell.innerHTML = header;

			cell.setAttribute('scope', 'col');
			headers.appendChild(cell);

		});

		data.forEach((card, idx) =>
		{
			let row = document.createElement('tr');
			row.classList.add('table-row')
			headersArr.forEach(header =>
			{
				let cell;
					cell = document.createElement('td');
					cell.innerHTML = `${header === 'Card Type' ? card.cardTypeName : 
						header === 'Brand' ? card.brand :
						header === 'Value' ? card.faceValue :
						header === 'Currency' ? card.currency : 
						header === 'Stock' ? card.stock :
						header === 'SKU' ? card.sku : 'Not Available'}`;
					cell.classList.add('text-truncate');
					cell.style.width = `${header === 'Card Type' ? '11vw': '60px'}`;
				
				row.appendChild(cell);
			});
			tblBody.appendChild(row);
		})

		tblHead.appendChild(headers);
		tbl.appendChild(tblHead)
		tbl.appendChild(tblBody);
		return tbl;
	}, [])

	const downloadPdf = useCallback(() => {
    let pdf = createTable(table.current.dataTable.data().toArray().map(card => ({...card, sku: card.sku ? card.sku : 'Not Available'})).sort(function (a, b)
		{
			var textA = a.sku.toUpperCase();
			var textB = b.sku.toUpperCase();
			return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
		}));
    var opt = {
      margin: [24, 15, 24, 15],
      filename:     `Available stock.pdf`,
			image: {type: 'jpg', quality: 0.98},
			html2canvas: {scale: 2, logging: true, dpi: 192, letterRendering: true },
			jsPDF: {unit: 'mm', format: 'letter', orientation: 'portrait'},
			pagebreak: { mode: ['css'] }
    };
    html2pdf(pdf, opt)
  },[createTable])

  const handleMainDropdownChange = (selectedValue, row) => {
    switch (selectedValue) {
      case 'gittcard_edit':
		editgiftcard(row)
       break;
      case 'supplier_edit':
		editSupplier(row)
      break;
    
      default:
        break;
    }
  }


const editgiftcard = (row) =>{
	const value = row?.data()
	toggleGiftcard()
	setStock(row?.data().stock)
	setOldCardId(row?.data()?.giftCardId)
	const brandOptions = {
	value:value?.brandId,
	label:value?.brand
	}
	setBrand(brandOptions)
	setBrandId(value?.brandId)
	const cardtypeOptions = {
	value:value?.giftCardId,
	label:value?.cardTypeName
	}
	setNewCardType(cardtypeOptions)
}

const editSupplier = (row) =>{
	
	
	toggleSupplier()

}
const downloadCsv = useCallback(() => {
    let csvRows = [];
    csvRows.push("Brand,Gift Card ID,Gift Card Name,SKU,Currency,Supplier,Order Number,Reference ID,Units on Stock");

    data.forEach(card => {
        card.inventoryInfo.forEach(info => {
            csvRows.push(
                `${card.brand},${card.giftCardId},${card.cardTypeName},${card.sku || 'Not Available'},${card.currency},${info.supplierName || 'Not Available'},${info.purchaseOrderName || 'Not Available'},${info.orderReference ? info.orderReference.trim() : 'Not Available'},${info.orderCount}`
            );
        });
    });

    let csvContent = csvRows.join("\n");

    const element = document.createElement("a");
    const file = new Blob([csvContent], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = `Available_stock.csv`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
}, [data]);




function onDraw() {
    if (table.current) {
      table.current.dataTable
        .rows()
        .eq(0)
        .each((i) => {
          const row = table.current.dataTable.row(i);
          const rowData = row.data();
          if (rowData) {
            let child = `<div class="row">
							<div class="col-2" id="Supplier-${rowData.giftCardId}" data-loaded="false">Loading info...</div>
							<div class="col-3" id="Date-${rowData.giftCardId}" data-loaded="false">Loading info...</div>
							<div class="col-3" id="orderNumber-${rowData.giftCardId}" data-loaded="false">Loading info...</div>
							<div class="col-2" id="RefId-${rowData.giftCardId}" data-loaded="false">Loading info...</div>
							<div class="col-2" id="stockUnit-${rowData.giftCardId}" data-loaded="false">Loading info...</div>
							
						</div>`;
            row.child(child).hide();
            row.child().addClass("ncentiva-datatable-child-row");
          }
        });
    }
  }

  function onRowCreated(row) {


    row.classList.add("ncentiva-datatable-row");
    row.addEventListener("click", () => {
      const thisRow = table.current.dataTable.row(row);
      if (thisRow.child.isShown()) {
        thisRow.child.hide();
      } else {
        thisRow.child.show();
      }
    });
  }
	useEffect(() =>
	{
		inventoryCtl.all(data => {
			if(data.error || data.errorMessage){
				setLoader(false)
				Notify(alert, 'danger', data.errorMessag ?? data.error)
			} else {
				setLoader(false)
				const mappedData = data.map(card => ({
                    ...card,
                    sku: card.sku ? card.sku : 'Not available'
                }));
				// setData(mappedData)

				if(table.current)
					table.current.dataTable.clear().rows.add(data.map(card => ({...card, sku: card.sku ? card.sku : 'Not available'}))).draw()
					table.current.dataTable.columns().search('').draw()
			}
		})
	},[cardTypeCtl, brands, inventoryCtl,ApiCallAgain])

	
	useEffect(()=>{
		inventoryCtl.supplierAll((data)=>{
        if(data && !data.error){
			const suppliers = data?.map((brand) => ({
				value: brand.id,
				label: brand.name,
				id: brand.id,
			  }));

			  setSupplierOption(suppliers)
		}else{
         
		}
		})
	},[inventoryCtl])

	useEffect(()=>{
		setShowDownload(true)
	inventoryCtl.getCsvDownloadData((data)=>{
		if(data && !data.error){
			setShowDownload(false)
			const mappedData = data.map(card => ({
				...card,
				sku: card.sku ? card.sku : 'Not available'
			}));
			setData(mappedData)
		}else{
			setTimeout(() => {
				setShowDownload(false);	
			}, 4000);
		}		
	})
	},[brands, inventoryCtl])

			useEffect(()=>{
		const value = brands?.map(item=>({
			value:item.id,
			label:item?.name
		}))
		setBrandOption(value)
			},[brands])

	function onChildRowData (_e, show, row) {
		if(show){
			const rowData = row.data();
			inventoryCtl.inventoryDetails(rowData?.giftCardId,(data)=>{
				if(data && !data?.error){
					setDetailsData(data)
					const apidata = data;
					const inventoryInfo = apidata?.inventoryInfo.sort((a, b) => new Date(a.date) - new Date(b.date));

			
					const supplierBlock = document.getElementById(`Supplier-${rowData.giftCardId}`);
					const DateBlock = document.getElementById(`Date-${rowData.giftCardId}`);
					const orderNumberBlock = document.getElementById(`orderNumber-${rowData.giftCardId}`);
					const refIdBlock = document.getElementById(`RefId-${rowData.giftCardId}`);
					const unitStock = document.getElementById(`stockUnit-${rowData.giftCardId}`);
			
					// Create HTML for inventory info
					const supplierHTML = inventoryInfo?.map(info => `<p style="text-align:center">${info.supplierName}</p>`).join('');
				    
					
					const DateHTML = inventoryInfo?.map(info => `<p style="text-align:center">${info.date}</p>`).join('');
					const orderNumberHTML = inventoryInfo?.map(info => `<p style="text-align:center">${info.purchaseOrderName}</p>`).join('');
					const refIdHTML = inventoryInfo?.map(info => `<p style="text-align:center">${info.orderReference ? info.orderReference : 'Not Available'}</p>`).join('');
					const unitStockHTML = inventoryInfo?.map(info => `<p style="text-align:center">${info.orderCount ? info.orderCount : 'Not Available'}</p>`).join('')
			
					supplierBlock.innerHTML = `<p style="text-align:center; font-weight: 600;">Supplier</p>${supplierHTML}`;
					DateBlock.innerHTML = `<p style="text-align:center; font-weight: 600;">Date</p>${DateHTML}`;
					orderNumberBlock.innerHTML = `<p style="text-align:center; font-weight: 600;">Order Number</p>${orderNumberHTML}`;
					refIdBlock.innerHTML = `<p style="text-align:center; font-weight: 600;">Ref ID</p>${refIdHTML}`;
					unitStock.innerHTML = `<p style="text-align:center; font-weight: 600;">Units on Stock</p>${unitStockHTML}`
				}else{
					
					const supplierBlock = document.getElementById(`Supplier-${rowData.giftCardId}`);
					const DateBlock = document.getElementById(`Date-${rowData.giftCardId}`);
					const orderNumberBlock = document.getElementById(`orderNumber-${rowData.giftCardId}`);
					const refIdBlock = document.getElementById(`RefId-${rowData.giftCardId}`);
					const unitStock = document.getElementById(`stockUnit-${rowData.giftCardId}`);

					const noDataHTML = `<p style="text-align:center">No data found</p>`;
					supplierBlock.innerHTML = noDataHTML;
					orderNumberBlock.innerHTML = noDataHTML;
					DateBlock.innerHTML = noDataHTML;
					refIdBlock.innerHTML = noDataHTML;
					unitStock.innerHTML = noDataHTML;
				}

			})
			
		   
		}
	}

	const onPurchaserOrder=()=>{
		if(accessRoles.includes("ACCOUNTANT_MANAGER") || accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE")) {
			  toggleWarning();
			  return;
			}
		history.push("/admin/inventory/purchaseorders")
	}

	const thresholdOrder = () =>{
	history.push("/admin/inventory/threshold")
	}

	const handleChange = (e) =>{
		const value = e.target.value
		setThresholdValue(value)
	}

	const handleBrandChange = (e) => {
		setBrand(e)
		if(e){
		setNewCardType([])
		}
		const brandId = e?.value
		setBrandId(brandId)
		if(brandId){
			inventoryCtl.denomination(brandId,(data)=>{
				if(data && !data.error){
					const fixedCard = data.filter(item => item.amount > 0)
					const cardoption = data.map((card)=>({
						value:card.id,
						label:card.productName
					}))
					setCardTypes(cardoption)
					let currencyData = data?.length > 0 && data[0]?.currency;
					let currencyID = data?.length > 0 && data[0]?.currencyId
					setCurrency(currencyData);
					setCurrencyId(currencyID);
				}else{
					cardTypeSelect.current.clearValue();
				}
			})
		}
		
		setCardsLoading(true);
		
	};

	const handleCardTypeChange = (selectedOption) =>{
		const CardId = selectedOption?.value
		setNewCardTypeId(CardId)
		setNewCardType(selectedOption)
        const value = selectedOption?.value
		setCardTypeId(value)
	}

	const addtoThreshold = () =>{
		let thresObj = {
			brandId:brandId,
			giftCardTypeId:cardTypeId,
			currencyId:currencyId,
			threshold:thresholdValue
		}
		inventoryCtl.createThreshold(thresObj,(data)=>{
			if(data && !data.error){
			  Notify(alert,"success","Threshold added successfully");
			}else{
				Notify(alert,'danger',data.errorMessag ?? data.error)
			}

		})
	}

	const handleEditBrand = () =>{
		setGiftcardLoader(true)
		if(brandId === "" || brandId === undefined){
			Notify(alert,"danger","Please select Brand");
			setGiftcardLoader(false)
			return;
		}else if(newCardTypeId === "" || newCardTypeId === undefined){
			Notify(alert,"danger","Please select New CardType");
			setGiftcardLoader(false)
			return;
		}else if(stock === "" || stock === undefined){
			Notify(alert,"danger","Stock can not be empty");
			setGiftcardLoader(false)
			return;
		}else{
			inventoryCtl.editGidtcard(oldCardId,newCardTypeId,stock,(data)=>{
				if(data && !data?.error){
                 Notify(alert,"success","Giftcard edit successfully");
				 setTimeout(() => {
					setGiftcardLoader(false)
				 }, 1000);
				 toggleGiftcard()
				 setApiCallAgain(prev=>prev+1)
				}else{
                  Notify(alert,"danger",data?.errorMessage ?? data?.error)
				  setTimeout(() => {
					setGiftcardLoader(false)
				 }, 1000);
				}
			})
			
		}
	}

	const handleSupplierModal = (item) =>{
		
		setSupplierGiftCard(detailsData?.giftCardId);
		setSupplierStock(item?.orderCount);
		setCurrentSupplierId(item?.supplierId);
		setReferenceId(item?.orderReference);
		const options = {
			value: item?.supplierId,
			label:item?.supplierName,
		}
		setSelectedChangeSupplier([options])

		toggleSingleEdit();

	}

	const handleSupplierChange = (options) =>{
		const value = options?.value
		setSelectedChangeSupplier(options)
		setNewSupplierId(value)
		
	}

	const handleSupplierUpdate = () =>{
		setSupplierEditLoader(true)
		if(newSupplierId === null || newSupplierId === undefined){
			Notify(alert,"danger","New Supplier should be selected");
			setSupplierEditLoader(false);
			return;
		}
		let SupplierObj = {
			giftCardTypeId:supplierGiftCard,
			currentSupplierId:currentSuppplierId,
			newSupplierId:newSupplierId,
			quantity:supplierStock,
			referenceId:referenceId,

		}
		if(SupplierObj){
          inventoryCtl.editSupplier(SupplierObj,(data)=>{
			if(data && !data?.error){
				Notify(alert,"success","Supplier edit Successfullly");
				setTimeout(() => {
					setSupplierEditLoader(false)
				}, 1000);
				toggleSingleEdit();
				inventoryCtl.inventoryDetails(supplierGiftCard,(data)=>{
					if(data && !data?.error){
						setDetailsData(data)
					}else{

					}
				})
			}else{
				Notify(alert,"danger",data?.errorMessage ?? data?.error)
				setTimeout(() => {
					setSupplierEditLoader(false)
				}, 1000);
			}
		  })
		}else{
			setSupplierEditLoader(false)
		}
	}

	const clearAllId = () =>{
		setSupplierGiftCard();
		setCurrentSupplierId();
		setNewSupplierId();
		setSupplierStock(null);
		setReferenceId()
	}

	return (<>
		<HistoricalDataSkuModal isOpen={isModalHistoryOpen} toggle={toggleModalHistory} />
		<NotificationAlert ref={alert}/>
		<div className="content">
			<Row>
				<Col md="12">
					<MotionCard initial={{width: "50%", height: "20%"}} animate={{width: "100%", height: "auto", transition: {duration: 0.3, ease: "easeOut"}}}>
						<CardHeader className="d-flex justify-content-between">
							<CardTitle tag="h4">Ncentiva SKU</CardTitle>
							<Row className="d-flex justify-content-end">
							<Col md='auto' style={{display:"flex",justifyContent:'end'}}>
									<MotionButton initial={{ x: "-500%", opacity: 0 }}
							
									animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  
									className="inventory btn btn-primaryTwo" 
									 
									onClick={thresholdOrder}>
										
										{' '}Inventory Threshold
									</MotionButton>
								</Col>
								<Col md='auto' style={{display:"flex",justifyContent:'end'}}>
									<MotionButton initial={{ x: "-500%", opacity: 0 }}
							
									animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  
									className="inventory btn btn-primaryTwo" 
									 
									onClick={onPurchaserOrder}>
										<i className="fas fa-download" />
										{' '}Purchaser Order
									</MotionButton>
								</Col>
								
								<Col md='auto' style={{display:"flex",justifyContent:'end'}}>
									<MotionButton initial={{ x: "-500%", opacity: 0 }} 
									animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  
									className="inventory btn btn-primaryTwo" 
									
									onClick={toggleDownloadBrandsModal}>
										<i className="fas fa-download" />
										{' '}Download Stock
									</MotionButton>
								</Col>
								<Col md='auto' style={{display:"flex",justifyContent:'end'}}>
									<MotionButton initial={{ x: "-500%", opacity: 0 }} 
									
									animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  
									className="inventory btn btn-primaryTwo" 
									onClick={toggleModalHistory}>
									<i className="fas fa-history pr-2"/>{' '}View historical data
									</MotionButton>
								</Col>
							</Row>
						</CardHeader>
						<CardBody>
						{loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:	
						<div className="data_table">
							<Datatable
								ref={table}
								columns={header}
								options={{
									dom: "tip",
									createdRow: onRowCreated,
									drawCallback: onDraw,
									saveState: true,
									lengthMenu: [
									  [20, 25, 50, -1],
									  [20, 25, 50, "All"],
									],
									saveState: false,
								   
								  }}
								  onChildRowChange={onChildRowData}
								data={null}
								enableSelectFilters={true}
								addmaindropdown={[{ callback: handleMainDropdownChange, selector: 'select.dropdown_value' }]}
							/>
							</div>
                            }
						</CardBody>
					</MotionCard>
				</Col>
			</Row>
			<Modal isOpen={modal} toggle={toggle} backdrop="static" size="sm" centered={true}>
				<ModalHeader toggle={toggle}>Add SKU file</ModalHeader>
				<ModalBody>
					<Form innerRef={form}>
						<Row form>
							<Col md={12}>
								<FormGroup>
									<Label for="file">Upload file</Label>
									<CustomInput
										label="choose file..."
										accept=".csv"
										type="file"
										name="file"
										id="fileInput"
										onChange={validateFile}
									/>
								</FormGroup>
							</Col>
						</Row>
					</Form>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
					<Button color="primary" onClick={uploadFile}>Upload</Button>
				</ModalFooter>
			</Modal>
			<Modal isOpen={downloadBrandsModal} toggle={toggleDownloadBrandsModal} backdrop="static" size="sm">
				<ModalHeader className="custom_header_colourTwo" toggle={toggleDownloadBrandsModal}>Available Brands</ModalHeader>
				<ModalBody>
					<Row className="mx-3">
					<Col md="12" className="d-contents" style={{ display: 'contents' }}>
						{
							showDownload ? 
							<Button className="card-just-text btn btn-primaryTwo"  style={{alignSelf:"center"}} disabled >
								{'Download excel file'}
								<Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{marginLeft:"5px"}}
                               />

							</Button>
							:
							<Button  className="card-just-text btn btn-primaryTwo"  style={{alignSelf:"center"}} disabled={false} onClick={downloadCsv}>
								{'Download excel file'}
							</Button>
						}
							
						</Col>
						{/* <Col md="6">
							<Button color="primary" className="card-just-text" disabled={false} onClick={downloadPdf}>
								{'Download PDF file'}
							</Button>
						</Col> */}
					</Row>
					<div id='pdf-container'></div>


				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleDownloadBrandsModal}>Close</Button>{' '}
				</ModalFooter>
			</Modal>
			<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
         </Modal>

			<Modal isOpen={giftcardEditModal} toggle={toggleGiftcard} backdrop="static">
		<ModalHeader toggle={toggleGiftcard}>Gift Card Edit Section</ModalHeader>
		<ModalBody>
			<div className="mb-3">
			<label className="form-label">Brand</label>
			<Select
				options={brandOption}
				value={brand}
				onChange={handleBrandChange}
				placeholder="Select a brand"
				isClearable={true}
			/>
			</div>
			<div className="mb-3">
			<label className="form-label">Gift Card</label>
			<Select
				options={cardTypes}
				value={newCardType}
				onChange={handleCardTypeChange}
				isClearable={true}
				placeholder="Select a gift card"
			/>
			</div>
			<div className="mb-3">
			<label className="form-label">Stock</label>
			<Input
				type="number"
				value={stock}
				onChange={(e) => setStock(e.target.value)}
				placeholder="Enter stock value"
			/>
			</div>
		</ModalBody>
		<ModalFooter>
			<Button className="btn btn-primaryTwo" onClick={handleEditBrand} disabled={giftCardLoader} >
			Save {
				giftCardLoader && 
				<Spinner
				as="span"
				animation="border"
				size="sm"
				role="status"
				aria-hidden="true"
				style={{marginLeft:"5px"}}
                />

			}
			</Button>
			<Button color="secondary" onClick={toggleGiftcard}>
			Close
			</Button>
      </ModalFooter>
    </Modal>
	<Modal isOpen={supplierEditModal} toggle={toggleSupplier} backdrop="static" size="lg">
      <ModalHeader toggle={()=>{toggleSupplier();clearAllId()}} style={{borderBottom:"0px"}}>Supplier Edit</ModalHeader>
      <ModalBody>
        <table className="table border">
          <thead style={{backgroundColor:"#f0f0f7"}} className="text-center">
            <tr>
              <th className="border-right border-2">Supplier</th>
              <th className="border-right border-2">Date</th>
              <th className="border-right border-2">Order Number</th>
              <th className="border-right border-2">Ref ID</th>
              <th className="border-right border-2">Units on Stock</th>
			  <th></th>
            </tr>
          </thead>
          <tbody className="text-center">
            {detailsData?.inventoryInfo?.map((item, index) => (
              <tr key={index}>
                <td>{item?.supplierName}</td>
                <td>{new Date(item?.date).toLocaleString()}</td>
                <td>{item?.purchaseOrderName}</td>
                <td>{item?.orderReference}</td>
                <td>{item?.orderCount}</td>
				<td><span className=" p-1 rounded-2  btn-primaryTwo" onClick={()=>handleSupplierModal(item)} style={{cursor:"pointer"}}><FiEdit2 /></span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={()=>{toggleSupplier();clearAllId()}}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
	<Modal isOpen={singleEditModal} toggle={toggleSingleEdit} backdrop="static">
      <ModalHeader toggle={()=>{toggleSingleEdit()}}>Supplier Edit Section</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label">Supplier</label>
          <Select
            options={supplierOption}
            value={selectedChangeSupplier}
            onChange={handleSupplierChange}
            placeholder="Select a supplier"
            isClearable={true}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-primaryTwo" onClick={handleSupplierUpdate} disabled={supplierEditLoader}>
          Save {
			supplierEditLoader && 
			<Spinner
			as="span"
			animation="border"
			size="sm"
			role="status"
			aria-hidden="true"
			style={{marginLeft:"5px"}}
            />

		  }
        </Button>
        <Button color="secondary" onClick={()=>{toggleSingleEdit()}} >
          Close
        </Button>
      </ModalFooter>
    </Modal>


		</div>
	</>);
}

export default InventoryView;
